/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:01]
Permissions to update outside the main branch: [true]
*/

import { DropDown, Tab } from '@finbeat/react-toolkit';
import { Key, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Trans } from 'react-i18next';
import { Nav, NavItem, NavLink, TabContent } from 'reactstrap';
import { defaultValues, OutletFormType } from './OutletChangeModal';
import TabApiSettings from './TabApiSettings';
import TabContanctFaces from './TabContanctFaces';
import TabHome from './TabHome';
import TabSettings from './TabSettings';

const homeTab = 'home';
const settingsTab = 'settings';
const apiSettingsTab = 'apiSettings';
const contanctFacesTab = 'contanctFaces';

type OutletChangeModalBodyProps = {
    formHasRole: boolean;
    showAdditionalSettings: boolean;
    showSettings: boolean;
    merchantRegions: DropDown[];
    typeWorks: DropDown[];
    isOutletDictsFetching: boolean;
    brandCode: DropDown[];
    isFetchingBrandCodeTypes: boolean;
};

const OutletChangeModalBody = ({
    formHasRole,
    showAdditionalSettings,
    showSettings,
    merchantRegions,
    typeWorks,
    isOutletDictsFetching,
    brandCode,
    isFetchingBrandCodeTypes,
}: OutletChangeModalBodyProps) => {
    const [activeTab, setActiveTab] = useState(homeTab);

    const toggleTab = (value?: Key) => {
        setActiveTab(value?.toString() ?? '');
    };

    const { watch, setValue } = useFormContext<OutletFormType>();
    const integrationType = watch('integrationType');

    useEffect(() => {
        if (integrationType !== 'API') {
            setValue('apiSettings', defaultValues.apiSettings);
        }
    }, [integrationType]);

    return (
        <div className="outlets">
            <div className="mb-3">
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            href="#"
                            onClick={() => setActiveTab(homeTab)}
                            active={activeTab === homeTab}
                        >
                            <Trans i18nKey="BackOfficeMainPageName" />
                        </NavLink>
                    </NavItem>
                    {showSettings && (
                        <NavItem>
                            <NavLink
                                href="#"
                                onClick={() => setActiveTab(settingsTab)}
                                active={activeTab === settingsTab}
                            >
                                <Trans i18nKey="BackOfficeSettings" />
                            </NavLink>
                        </NavItem>
                    )}
                    {showAdditionalSettings && integrationType && integrationType === 'API' && (
                        <NavItem>
                            <NavLink
                                href="#"
                                onClick={() => setActiveTab(apiSettingsTab)}
                                active={activeTab === apiSettingsTab}
                            >
                                <Trans i18nKey="BackOfficeApiSettings" />
                            </NavLink>
                        </NavItem>
                    )}

                    <NavItem>
                        <NavLink
                            href="#"
                            onClick={() => setActiveTab(contanctFacesTab)}
                            active={activeTab === contanctFacesTab}
                        >
                            <Trans i18nKey="BackOfficeContactFaces" />
                        </NavLink>
                    </NavItem>
                </Nav>
            </div>
            <div className="outlets__tab custom-scrollbar px-3">
                <TabContent activeTab={activeTab}>
                    <Tab toggle={toggleTab} tabId={homeTab}>
                        <TabHome
                            isOpen={activeTab === homeTab}
                            formHasRole={formHasRole}
                            showAdditionalSettings={showAdditionalSettings}
                            merchantRegions={merchantRegions}
                            typeWorks={typeWorks}
                            isOutletDictsFetching={isOutletDictsFetching}
                            brandCode={brandCode}
                            isFetchingBrandCodeTypes={isFetchingBrandCodeTypes}
                        />
                    </Tab>
                    {showSettings && (
                        <Tab toggle={toggleTab} tabId={settingsTab}>
                            <TabSettings
                                isOpen={activeTab === settingsTab}
                                formHasRole={formHasRole}
                            />
                        </Tab>
                    )}
                    {showAdditionalSettings && integrationType && integrationType === 'API' && (
                        <Tab toggle={toggleTab} tabId={apiSettingsTab}>
                            <TabApiSettings
                                isOpen={activeTab === apiSettingsTab}
                                formHasRole={formHasRole}
                            />
                        </Tab>
                    )}
                    <Tab toggle={toggleTab} tabId={contanctFacesTab}>
                        <TabContanctFaces
                            isOpen={activeTab === contanctFacesTab}
                            formHasRole={formHasRole}
                        />
                    </Tab>
                </TabContent>
            </div>
        </div>
    );
};

export default OutletChangeModalBody;
